<div class="contentMain">
    <!-- breadcrumb -->
    <div class="row">
      <div class="col-md-12 card-header mainheader header-container-btn">
        <h5>Account Creation</h5>
      </div>
      <!-- <div class="col-md-6 ">
              <ol class="breadcrum d-flex justify-content-end">
                  <li class="breadcrumb-item"><a href="#">Home</a></li>
                  <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                  <li class="breadcrumb-item active" aria-current="page">Account Creation</li>
              </ol>
          </div> -->
    </div>
    <!--/ breadcrumb-->
    <!-- main body -->
    <main class="row">
      <div class="card">
        <!-- card body -->
        <div class="card-body">
          <!-- bootstrap tabs -->
          <div class="kliqtab">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs p-0 mb-3">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#General"
                  >General</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#Address">Address</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#Specialoption"
                  >Special Option</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#Bank">Bank</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#customFields"
                  >Custom Fields</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#gst">GST</a>
              </li>
            </ul>
            <!-- Tab panes -->
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane in active p-3" id="General">
                <!-- general -->
                <div class="row">
                  <!-- col -->
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-md-9">
                    <!--/ row -->
                    <div class="row">
                      <!-- col -->
                      <div class="col-lg-12 col-md-12 col-sm-6">
                        <div class="form-group">
                          <label>Account Type</label>
                          <select
                            class="form-control show-tick ms select2"
                            data-placeholder="Select"
                          >
                            <option>Select Salesman Type</option>
                            <option>Customer</option>
                            <option>Type Customer</option>
                            <option>Vendor</option>
                            <option>Relish</option>
                          </select>
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-12 col-md-12 col-sm-6">
                        <div class="form-group">
                          <label>Account Name</label>
                          <span
                            ><input
                              type="text"
                              class="form-control"
                              placeholder="Write Account Name"
                          /></span>
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-6 col-md-8 col-sm-6">
                        <div class="form-group">
                          <label>Alias Name</label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Write Alias Name"
                          />
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-6 col-md-8 col-sm-6">
                        <div class="form-group">
                          <label>Account Code</label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Account Code"
                          />
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-6 col-md-8 col-sm-6">
                        <div class="form-group">
                          <label>Bill Mode</label>
                          <div
                            class="
                              select2-container
                              form-control
                              show-tick
                              ms
                              select2
                            "
                            id="s2id_autogen3"
                          >
                            <a
                              href="javascript:void(0)"
                              class="select2-choice"
                              tabindex="-1"
                            >
                              <span class="select2-chosen" id="select2-chosen-4"
                                >Select</span
                              ><abbr class="select2-search-choice-close"></abbr>
                              <span class="select2-arrow" role="presentation"
                                ><b role="presentation"></b></span></a
                            ><label
                              for="s2id_autogen4"
                              class="select2-offscreen"
                            ></label
                            ><input
                              class="select2-focusser select2-offscreen"
                              type="text"
                              aria-haspopup="true"
                              role="button"
                              aria-labelledby="select2-chosen-4"
                              id="s2id_autogen4"
                            />
                            <div
                              class="
                                select2-drop
                                select2-display-none
                                select2-with-searchbox
                              "
                            >
                              <div class="select2-search">
                                <label
                                  for="s2id_autogen4_search"
                                  class="select2-offscreen"
                                ></label>
                                <input
                                  type="text"
                                  autocomplete="off"
                                  autocorrect="off"
                                  autocapitalize="off"
                                  spellcheck="false"
                                  class="select2-input"
                                  role="combobox"
                                  aria-expanded="true"
                                  aria-autocomplete="list"
                                  aria-owns="select2-results-4"
                                  id="s2id_autogen4_search"
                                  placeholder=""
                                />
                              </div>
                              <ul
                                class="select2-results"
                                role="listbox"
                                id="select2-results-4"
                              ></ul>
                            </div>
                          </div>
                          <select
                            class="form-control show-tick ms select2"
                            data-placeholder="Select"
                            tabindex="-1"
                            title=""
                            style="display: none"
                          >
                            <option>Select</option>
                            <option>Customer</option>
                            <option>Type Customer</option>
                            <option>Vendor</option>
                            <option>Relish</option>
                          </select>
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-6 col-md-8 col-sm-6">
                        <div class="form-group">
                          <label>Sub Account</label>
                          <div
                            class="
                              select2-container
                              form-control
                              show-tick
                              ms
                              select2
                            "
                            id="s2id_autogen5"
                          >
                            <a
                              href="javascript:void(0)"
                              class="select2-choice"
                              tabindex="-1"
                            >
                              <span class="select2-chosen" id="select2-chosen-6"
                                >Select</span
                              ><abbr class="select2-search-choice-close"></abbr>
                              <span class="select2-arrow" role="presentation"
                                ><b role="presentation"></b></span></a
                            ><label
                              for="s2id_autogen6"
                              class="select2-offscreen"
                            ></label
                            ><input
                              class="select2-focusser select2-offscreen"
                              type="text"
                              aria-haspopup="true"
                              role="button"
                              aria-labelledby="select2-chosen-6"
                              id="s2id_autogen6"
                            />
                            <div
                              class="
                                select2-drop
                                select2-display-none
                                select2-with-searchbox
                              "
                            >
                              <div class="select2-search">
                                <label
                                  for="s2id_autogen6_search"
                                  class="select2-offscreen"
                                ></label>
                                <input
                                  type="text"
                                  autocomplete="off"
                                  autocorrect="off"
                                  autocapitalize="off"
                                  spellcheck="false"
                                  class="select2-input"
                                  role="combobox"
                                  aria-expanded="true"
                                  aria-autocomplete="list"
                                  aria-owns="select2-results-6"
                                  id="s2id_autogen6_search"
                                  placeholder=""
                                />
                              </div>
                              <ul
                                class="select2-results"
                                role="listbox"
                                id="select2-results-6"
                              ></ul>
                            </div>
                          </div>
                          <select
                            class="form-control show-tick ms select2"
                            data-placeholder="Select"
                            tabindex="-1"
                            title=""
                            style="display: none"
                          >
                            <option>Select</option>
                            <option>Select Item1</option>
                            <option>Select Item2</option>
                            <option>Select Item3</option>
                            <option>Select Item4</option>
                          </select>
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-6 col-md-8 col-sm-6">
                        <div class="form-group">
                          <label>Transaction Type</label>
                          <div
                            class="
                              select2-container
                              form-control
                              show-tick
                              ms
                              select2
                            "
                            id="s2id_autogen7"
                          >
                            <a
                              href="javascript:void(0)"
                              class="select2-choice"
                              tabindex="-1"
                            >
                              <span class="select2-chosen" id="select2-chosen-8"
                                >Select</span
                              ><abbr class="select2-search-choice-close"></abbr>
                              <span class="select2-arrow" role="presentation"
                                ><b role="presentation"></b></span></a
                            ><label
                              for="s2id_autogen8"
                              class="select2-offscreen"
                            ></label
                            ><input
                              class="select2-focusser select2-offscreen"
                              type="text"
                              aria-haspopup="true"
                              role="button"
                              aria-labelledby="select2-chosen-8"
                              id="s2id_autogen8"
                            />
                            <div
                              class="
                                select2-drop
                                select2-display-none
                                select2-with-searchbox
                              "
                            >
                              <div class="select2-search">
                                <label
                                  for="s2id_autogen8_search"
                                  class="select2-offscreen"
                                ></label>
                                <input
                                  type="text"
                                  autocomplete="off"
                                  autocorrect="off"
                                  autocapitalize="off"
                                  spellcheck="false"
                                  class="select2-input"
                                  role="combobox"
                                  aria-expanded="true"
                                  aria-autocomplete="list"
                                  aria-owns="select2-results-8"
                                  id="s2id_autogen8_search"
                                  placeholder=""
                                />
                              </div>
                              <ul
                                class="select2-results"
                                role="listbox"
                                id="select2-results-8"
                              ></ul>
                            </div>
                          </div>
                          <select
                            class="form-control show-tick ms select2"
                            data-placeholder="Select"
                            tabindex="-1"
                            title=""
                            style="display: none"
                          >
                            <option>Select</option>
                            <option>Select Item1</option>
                            <option>Select Item2</option>
                            <option>Select Item3</option>
                            <option>Select Item4</option>
                          </select>
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-6 col-md-8 col-sm-6">
                        <div class="form-group">
                          <label>Tax Type</label>
                          <div
                            class="
                              select2-container
                              form-control
                              show-tick
                              ms
                              select2
                            "
                            id="s2id_autogen9"
                          >
                            <a
                              href="javascript:void(0)"
                              class="select2-choice"
                              tabindex="-1"
                            >
                              <span class="select2-chosen" id="select2-chosen-10"
                                >Select</span
                              ><abbr class="select2-search-choice-close"></abbr>
                              <span class="select2-arrow" role="presentation"
                                ><b role="presentation"></b></span></a
                            ><label
                              for="s2id_autogen10"
                              class="select2-offscreen"
                            ></label
                            ><input
                              class="select2-focusser select2-offscreen"
                              type="text"
                              aria-haspopup="true"
                              role="button"
                              aria-labelledby="select2-chosen-10"
                              id="s2id_autogen10"
                            />
                            <div
                              class="
                                select2-drop
                                select2-display-none
                                select2-with-searchbox
                              "
                            >
                              <div class="select2-search">
                                <label
                                  for="s2id_autogen10_search"
                                  class="select2-offscreen"
                                ></label>
                                <input
                                  type="text"
                                  autocomplete="off"
                                  autocorrect="off"
                                  autocapitalize="off"
                                  spellcheck="false"
                                  class="select2-input"
                                  role="combobox"
                                  aria-expanded="true"
                                  aria-autocomplete="list"
                                  aria-owns="select2-results-10"
                                  id="s2id_autogen10_search"
                                  placeholder=""
                                />
                              </div>
                              <ul
                                class="select2-results"
                                role="listbox"
                                id="select2-results-10"
                              ></ul>
                            </div>
                          </div>
                          <select
                            class="form-control show-tick ms select2"
                            data-placeholder="Select"
                            tabindex="-1"
                            title=""
                            style="display: none"
                          >
                            <option>Select</option>
                            <option>Select Item1</option>
                            <option>Select Item2</option>
                            <option>Select Item3</option>
                            <option>Select Item4</option>
                          </select>
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-6 col-md-8 col-sm-6">
                        <div class="form-group">
                          <label>Salesman</label>
                          <div
                            class="
                              select2-container
                              form-control
                              show-tick
                              ms
                              select2
                            "
                            id="s2id_autogen11"
                          >
                            <a
                              href="javascript:void(0)"
                              class="select2-choice"
                              tabindex="-1"
                            >
                              <span class="select2-chosen" id="select2-chosen-12"
                                >Select</span
                              ><abbr class="select2-search-choice-close"></abbr>
                              <span class="select2-arrow" role="presentation"
                                ><b role="presentation"></b></span></a
                            ><label
                              for="s2id_autogen12"
                              class="select2-offscreen"
                            ></label
                            ><input
                              class="select2-focusser select2-offscreen"
                              type="text"
                              aria-haspopup="true"
                              role="button"
                              aria-labelledby="select2-chosen-12"
                              id="s2id_autogen12"
                            />
                            <div
                              class="
                                select2-drop
                                select2-display-none
                                select2-with-searchbox
                              "
                            >
                              <div class="select2-search">
                                <label
                                  for="s2id_autogen12_search"
                                  class="select2-offscreen"
                                ></label>
                                <input
                                  type="text"
                                  autocomplete="off"
                                  autocorrect="off"
                                  autocapitalize="off"
                                  spellcheck="false"
                                  class="select2-input"
                                  role="combobox"
                                  aria-expanded="true"
                                  aria-autocomplete="list"
                                  aria-owns="select2-results-12"
                                  id="s2id_autogen12_search"
                                  placeholder=""
                                />
                              </div>
                              <ul
                                class="select2-results"
                                role="listbox"
                                id="select2-results-12"
                              ></ul>
                            </div>
                          </div>
                          <select
                            class="form-control show-tick ms select2"
                            data-placeholder="Select"
                            tabindex="-1"
                            title=""
                            style="display: none"
                          >
                            <option>Select</option>
                            <option>Select Item1</option>
                            <option>Select Item2</option>
                            <option>Select Item3</option>
                            <option>Select Item4</option>
                          </select>
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-6 col-md-8 col-sm-6">
                        <div class="form-group">
                          <label>Branch Type</label>
                          <div
                            class="
                              select2-container select2-container-disabled
                              form-control
                              show-tick
                              ms
                              select2
                              disabled
                            "
                            id="s2id_autogen13"
                          >
                            <a
                              href="javascript:void(0)"
                              class="select2-choice"
                              tabindex="-1"
                            >
                              <span class="select2-chosen" id="select2-chosen-14"
                                >Select</span
                              ><abbr class="select2-search-choice-close"></abbr>
                              <span class="select2-arrow" role="presentation"
                                ><b role="presentation"></b></span></a
                            ><label
                              for="s2id_autogen14"
                              class="select2-offscreen"
                            ></label
                            ><input
                              class="select2-focusser select2-offscreen"
                              type="text"
                              aria-haspopup="true"
                              role="button"
                              aria-labelledby="select2-chosen-14"
                              id="s2id_autogen14"
                              disabled=""
                            />
                            <div
                              class="
                                select2-drop
                                select2-display-none
                                select2-with-searchbox
                              "
                            >
                              <div class="select2-search">
                                <label
                                  for="s2id_autogen14_search"
                                  class="select2-offscreen"
                                ></label>
                                <input
                                  type="text"
                                  autocomplete="off"
                                  autocorrect="off"
                                  autocapitalize="off"
                                  spellcheck="false"
                                  class="select2-input"
                                  role="combobox"
                                  aria-expanded="true"
                                  aria-autocomplete="list"
                                  aria-owns="select2-results-14"
                                  id="s2id_autogen14_search"
                                  placeholder=""
                                />
                              </div>
                              <ul
                                class="select2-results"
                                role="listbox"
                                id="select2-results-14"
                              ></ul>
                            </div>
                          </div>
                          <select
                            class="form-control show-tick ms select2 disabled"
                            data-placeholder="Select"
                            disabled=""
                            tabindex="-1"
                            title=""
                            style="display: none"
                          >
                            <option>Select</option>
                            <option>Select Item1</option>
                            <option>Select Item2</option>
                            <option>Select Item3</option>
                            <option>Select Item4</option>
                          </select>
                        </div>
                      </div>
                      <!--/ col -->
                      <!-- col -->
                      <div class="col-lg-8 col-md-10 col-sm-6">
                        <div class="row">
                          <div class="form-group col-8">
                            <label>Registration Type</label>
                            <div
                              class="
                                select2-container
                                form-control
                                show-tick
                                ms
                                select2
                              "
                              id="s2id_autogen15"
                            >
                              <a
                                href="javascript:void(0)"
                                class="select2-choice"
                                tabindex="-1"
                              >
                                <span
                                  class="select2-chosen"
                                  id="select2-chosen-16"
                                  >Select</span
                                ><abbr class="select2-search-choice-close"></abbr>
                                <span class="select2-arrow" role="presentation"
                                  ><b role="presentation"></b></span></a
                              ><label
                                for="s2id_autogen16"
                                class="select2-offscreen"
                              ></label
                              ><input
                                class="select2-focusser select2-offscreen"
                                type="text"
                                aria-haspopup="true"
                                role="button"
                                aria-labelledby="select2-chosen-16"
                                id="s2id_autogen16"
                              />
                              <div
                                class="
                                  select2-drop
                                  select2-display-none
                                  select2-with-searchbox
                                "
                              >
                                <div class="select2-search">
                                  <label
                                    for="s2id_autogen16_search"
                                    class="select2-offscreen"
                                  ></label>
                                  <input
                                    type="text"
                                    autocomplete="off"
                                    autocorrect="off"
                                    autocapitalize="off"
                                    spellcheck="false"
                                    class="select2-input"
                                    role="combobox"
                                    aria-expanded="true"
                                    aria-autocomplete="list"
                                    aria-owns="select2-results-16"
                                    id="s2id_autogen16_search"
                                    placeholder=""
                                  />
                                </div>
                                <ul
                                  class="select2-results"
                                  role="listbox"
                                  id="select2-results-16"
                                ></ul>
                              </div>
                            </div>
                            <select
                              class="form-control show-tick ms select2"
                              data-placeholder="Select"
                              tabindex="-1"
                              title=""
                              style="display: none"
                            >
                              <option>Select</option>
                              <option>Select Item1</option>
                              <option>Select Item2</option>
                              <option>Select Item3</option>
                              <option>Select Item4</option>
                            </select>
                          </div>
                          <div class="checkbox col-4 pt-4">
                            <input id="remember_me" type="checkbox" />
                            <label for="remember_me"> TCS </label>
                          </div>
                        </div>
                      </div>
                      <!--/ col -->
                    </div>
                    <!--/ row -->
                  </div>
                  <!--/ col -->
                  <div class="col-md-3">
                    <!-- buttons -->
                    <div class="d-grid gap-2 d-md-block text-center">
                      <button
                        class="btn btn-secondary disabled rounded-pill"
                        type="button"
                      >
                        Active
                      </button>
                      <button
                        class="btn btn-primary redbtn rounded-pill"
                        type="button"
                      >
                        Block
                      </button>
                    </div>
                    <!--/ buttons -->
                    <figure class="avatarImg text-center">
                      <img
                        src="./assets/images/avatar1.jpg"
                        class="rounded-circle"
                        alt="Profile Image"
                      />
                    </figure>
                    <!-- buttons -->
                    <div class="d-grid gap-2 d-md-block text-center">
                      <button
                        class="btn btn-outline-primary brdbtn rounded-pill"
                        type="button"
                      >
                        Web Cam
                      </button>
                      <button
                        class="btn btn-outline-primary brdbtn rounded-pill"
                        type="button"
                        data-target="#uploadImage"
                        data-toggle="modal"
                      >
                        Select Image
                      </button>
                    </div>
                    <!--/ buttons -->
                  </div>
                </div>
                <!--/ general -->
                <!-- Branch Permissions -->
                <div class="row border-top mt-3">
                  <div class="col-12">
                    <h5 class="py-3">Branch Permissions</h5>
                    <!-- table -->
                    <div class="table-responsive">
                      <div class="checkbox">
                        <input id="selectall" type="checkbox" />
                        <label for="selectall"> Select All </label>
                      </div>
                      <table class="table m-b-0 kliqtable">
                        <thead>
                          <tr>
                            <th scope="col">Check</th>
                            <th scope="col">Branch Name</th>
                            <th scope="col" class="text-right">
                              Current Year OP Bal
                            </th>
                            <th scope="col">Sign</th>
                            <th scope="col" class="text-right">
                              Previous Year OP Bal
                            </th>
                            <th scope="col">Sign</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">
                              <div class="checkbox">
                                <input id="check1" type="checkbox" />
                                <label for="check1"> &nbsp; </label>
                              </div>
                            </th>
                            <td>Branch Office</td>
                            <td align="right">0.00</td>
                            <td>
                              <div class="form-group">
                                <div
                                  class="
                                    select2-container
                                    form-control
                                    show-tick
                                    ms
                                    select2
                                  "
                                  id="s2id_autogen17"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    class="select2-choice"
                                    tabindex="-1"
                                  >
                                    <span
                                      class="select2-chosen"
                                      id="select2-chosen-18"
                                      >Dr</span
                                    ><abbr
                                      class="select2-search-choice-close"
                                    ></abbr>
                                    <span
                                      class="select2-arrow"
                                      role="presentation"
                                      ><b role="presentation"></b></span></a
                                  ><label
                                    for="s2id_autogen18"
                                    class="select2-offscreen"
                                  ></label
                                  ><input
                                    class="select2-focusser select2-offscreen"
                                    type="text"
                                    aria-haspopup="true"
                                    role="button"
                                    aria-labelledby="select2-chosen-18"
                                    id="s2id_autogen18"
                                  />
                                  <div
                                    class="
                                      select2-drop
                                      select2-display-none
                                      select2-with-searchbox
                                    "
                                  >
                                    <div class="select2-search">
                                      <label
                                        for="s2id_autogen18_search"
                                        class="select2-offscreen"
                                      ></label>
                                      <input
                                        type="text"
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        class="select2-input"
                                        role="combobox"
                                        aria-expanded="true"
                                        aria-autocomplete="list"
                                        aria-owns="select2-results-18"
                                        id="s2id_autogen18_search"
                                        placeholder=""
                                      />
                                    </div>
                                    <ul
                                      class="select2-results"
                                      role="listbox"
                                      id="select2-results-18"
                                    ></ul>
                                  </div>
                                </div>
                                <select
                                  class="form-control show-tick ms select2"
                                  data-placeholder="Select"
                                  tabindex="-1"
                                  title=""
                                  style="display: none"
                                >
                                  <option>Dr</option>
                                  <option>Select Item1</option>
                                  <option>Select Item2</option>
                                  <option>Select Item3</option>
                                  <option>Select Item4</option>
                                </select>
                              </div>
                            </td>
                            <td align="right">0.00</td>
                            <td>
                              <div class="form-group">
                                <div
                                  class="
                                    select2-container
                                    form-control
                                    show-tick
                                    ms
                                    select2
                                  "
                                  id="s2id_autogen19"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    class="select2-choice"
                                    tabindex="-1"
                                  >
                                    <span
                                      class="select2-chosen"
                                      id="select2-chosen-20"
                                      >Dr</span
                                    ><abbr
                                      class="select2-search-choice-close"
                                    ></abbr>
                                    <span
                                      class="select2-arrow"
                                      role="presentation"
                                      ><b role="presentation"></b></span></a
                                  ><label
                                    for="s2id_autogen20"
                                    class="select2-offscreen"
                                  ></label
                                  ><input
                                    class="select2-focusser select2-offscreen"
                                    type="text"
                                    aria-haspopup="true"
                                    role="button"
                                    aria-labelledby="select2-chosen-20"
                                    id="s2id_autogen20"
                                  />
                                  <div
                                    class="
                                      select2-drop
                                      select2-display-none
                                      select2-with-searchbox
                                    "
                                  >
                                    <div class="select2-search">
                                      <label
                                        for="s2id_autogen20_search"
                                        class="select2-offscreen"
                                      ></label>
                                      <input
                                        type="text"
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        class="select2-input"
                                        role="combobox"
                                        aria-expanded="true"
                                        aria-autocomplete="list"
                                        aria-owns="select2-results-20"
                                        id="s2id_autogen20_search"
                                        placeholder=""
                                      />
                                    </div>
                                    <ul
                                      class="select2-results"
                                      role="listbox"
                                      id="select2-results-20"
                                    ></ul>
                                  </div>
                                </div>
                                <select
                                  class="form-control show-tick ms select2"
                                  data-placeholder="Select"
                                  tabindex="-1"
                                  title=""
                                  style="display: none"
                                >
                                  <option>Dr</option>
                                  <option>Select Item1</option>
                                  <option>Select Item2</option>
                                  <option>Select Item3</option>
                                  <option>Select Item4</option>
                                </select>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              <div class="checkbox">
                                <input id="check1" type="checkbox" />
                                <label for="check1"> &nbsp; </label>
                              </div>
                            </th>
                            <td>Branch Office</td>
                            <td align="right">0.00</td>
                            <td>
                              <div class="form-group">
                                <div
                                  class="
                                    select2-container
                                    form-control
                                    show-tick
                                    ms
                                    select2
                                  "
                                  id="s2id_autogen21"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    class="select2-choice"
                                    tabindex="-1"
                                  >
                                    <span
                                      class="select2-chosen"
                                      id="select2-chosen-22"
                                      >Dr</span
                                    ><abbr
                                      class="select2-search-choice-close"
                                    ></abbr>
                                    <span
                                      class="select2-arrow"
                                      role="presentation"
                                      ><b role="presentation"></b></span></a
                                  ><label
                                    for="s2id_autogen22"
                                    class="select2-offscreen"
                                  ></label
                                  ><input
                                    class="select2-focusser select2-offscreen"
                                    type="text"
                                    aria-haspopup="true"
                                    role="button"
                                    aria-labelledby="select2-chosen-22"
                                    id="s2id_autogen22"
                                  />
                                  <div
                                    class="
                                      select2-drop
                                      select2-display-none
                                      select2-with-searchbox
                                    "
                                  >
                                    <div class="select2-search">
                                      <label
                                        for="s2id_autogen22_search"
                                        class="select2-offscreen"
                                      ></label>
                                      <input
                                        type="text"
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        class="select2-input"
                                        role="combobox"
                                        aria-expanded="true"
                                        aria-autocomplete="list"
                                        aria-owns="select2-results-22"
                                        id="s2id_autogen22_search"
                                        placeholder=""
                                      />
                                    </div>
                                    <ul
                                      class="select2-results"
                                      role="listbox"
                                      id="select2-results-22"
                                    ></ul>
                                  </div>
                                </div>
                                <select
                                  class="form-control show-tick ms select2"
                                  data-placeholder="Select"
                                  tabindex="-1"
                                  title=""
                                  style="display: none"
                                >
                                  <option>Dr</option>
                                  <option>Select Item1</option>
                                  <option>Select Item2</option>
                                  <option>Select Item3</option>
                                  <option>Select Item4</option>
                                </select>
                              </div>
                            </td>
                            <td align="right">0.00</td>
                            <td>
                              <div class="form-group">
                                <div
                                  class="
                                    select2-container
                                    form-control
                                    show-tick
                                    ms
                                    select2
                                  "
                                  id="s2id_autogen23"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    class="select2-choice"
                                    tabindex="-1"
                                  >
                                    <span
                                      class="select2-chosen"
                                      id="select2-chosen-24"
                                      >Dr</span
                                    ><abbr
                                      class="select2-search-choice-close"
                                    ></abbr>
                                    <span
                                      class="select2-arrow"
                                      role="presentation"
                                      ><b role="presentation"></b></span></a
                                  ><label
                                    for="s2id_autogen24"
                                    class="select2-offscreen"
                                  ></label
                                  ><input
                                    class="select2-focusser select2-offscreen"
                                    type="text"
                                    aria-haspopup="true"
                                    role="button"
                                    aria-labelledby="select2-chosen-24"
                                    id="s2id_autogen24"
                                  />
                                  <div
                                    class="
                                      select2-drop
                                      select2-display-none
                                      select2-with-searchbox
                                    "
                                  >
                                    <div class="select2-search">
                                      <label
                                        for="s2id_autogen24_search"
                                        class="select2-offscreen"
                                      ></label>
                                      <input
                                        type="text"
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        class="select2-input"
                                        role="combobox"
                                        aria-expanded="true"
                                        aria-autocomplete="list"
                                        aria-owns="select2-results-24"
                                        id="s2id_autogen24_search"
                                        placeholder=""
                                      />
                                    </div>
                                    <ul
                                      class="select2-results"
                                      role="listbox"
                                      id="select2-results-24"
                                    ></ul>
                                  </div>
                                </div>
                                <select
                                  class="form-control show-tick ms select2"
                                  data-placeholder="Select"
                                  tabindex="-1"
                                  title=""
                                  style="display: none"
                                >
                                  <option>Dr</option>
                                  <option>Select Item1</option>
                                  <option>Select Item2</option>
                                  <option>Select Item3</option>
                                  <option>Select Item4</option>
                                </select>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              <div class="checkbox">
                                <input id="check1" type="checkbox" />
                                <label for="check1"> &nbsp; </label>
                              </div>
                            </th>
                            <td>Branch Office</td>
                            <td align="right">0.00</td>
                            <td>
                              <div class="form-group">
                                <div
                                  class="
                                    select2-container
                                    form-control
                                    show-tick
                                    ms
                                    select2
                                  "
                                  id="s2id_autogen25"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    class="select2-choice"
                                    tabindex="-1"
                                  >
                                    <span
                                      class="select2-chosen"
                                      id="select2-chosen-26"
                                      >Dr</span
                                    ><abbr
                                      class="select2-search-choice-close"
                                    ></abbr>
                                    <span
                                      class="select2-arrow"
                                      role="presentation"
                                      ><b role="presentation"></b></span></a
                                  ><label
                                    for="s2id_autogen26"
                                    class="select2-offscreen"
                                  ></label
                                  ><input
                                    class="select2-focusser select2-offscreen"
                                    type="text"
                                    aria-haspopup="true"
                                    role="button"
                                    aria-labelledby="select2-chosen-26"
                                    id="s2id_autogen26"
                                  />
                                  <div
                                    class="
                                      select2-drop
                                      select2-display-none
                                      select2-with-searchbox
                                    "
                                  >
                                    <div class="select2-search">
                                      <label
                                        for="s2id_autogen26_search"
                                        class="select2-offscreen"
                                      ></label>
                                      <input
                                        type="text"
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        class="select2-input"
                                        role="combobox"
                                        aria-expanded="true"
                                        aria-autocomplete="list"
                                        aria-owns="select2-results-26"
                                        id="s2id_autogen26_search"
                                        placeholder=""
                                      />
                                    </div>
                                    <ul
                                      class="select2-results"
                                      role="listbox"
                                      id="select2-results-26"
                                    ></ul>
                                  </div>
                                </div>
                                <select
                                  class="form-control show-tick ms select2"
                                  data-placeholder="Select"
                                  tabindex="-1"
                                  title=""
                                  style="display: none"
                                >
                                  <option>Dr</option>
                                  <option>Select Item1</option>
                                  <option>Select Item2</option>
                                  <option>Select Item3</option>
                                  <option>Select Item4</option>
                                </select>
                              </div>
                            </td>
                            <td align="right">0.00</td>
                            <td>
                              <div class="form-group">
                                <div
                                  class="
                                    select2-container
                                    form-control
                                    show-tick
                                    ms
                                    select2
                                  "
                                  id="s2id_autogen27"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    class="select2-choice"
                                    tabindex="-1"
                                  >
                                    <span
                                      class="select2-chosen"
                                      id="select2-chosen-28"
                                      >Dr</span
                                    ><abbr
                                      class="select2-search-choice-close"
                                    ></abbr>
                                    <span
                                      class="select2-arrow"
                                      role="presentation"
                                      ><b role="presentation"></b></span></a
                                  ><label
                                    for="s2id_autogen28"
                                    class="select2-offscreen"
                                  ></label
                                  ><input
                                    class="select2-focusser select2-offscreen"
                                    type="text"
                                    aria-haspopup="true"
                                    role="button"
                                    aria-labelledby="select2-chosen-28"
                                    id="s2id_autogen28"
                                  />
                                  <div
                                    class="
                                      select2-drop
                                      select2-display-none
                                      select2-with-searchbox
                                    "
                                  >
                                    <div class="select2-search">
                                      <label
                                        for="s2id_autogen28_search"
                                        class="select2-offscreen"
                                      ></label>
                                      <input
                                        type="text"
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        class="select2-input"
                                        role="combobox"
                                        aria-expanded="true"
                                        aria-autocomplete="list"
                                        aria-owns="select2-results-28"
                                        id="s2id_autogen28_search"
                                        placeholder=""
                                      />
                                    </div>
                                    <ul
                                      class="select2-results"
                                      role="listbox"
                                      id="select2-results-28"
                                    ></ul>
                                  </div>
                                </div>
                                <select
                                  class="form-control show-tick ms select2"
                                  data-placeholder="Select"
                                  tabindex="-1"
                                  title=""
                                  style="display: none"
                                >
                                  <option>Dr</option>
                                  <option>Select Item1</option>
                                  <option>Select Item2</option>
                                  <option>Select Item3</option>
                                  <option>Select Item4</option>
                                </select>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!--/ table -->
                    <div class="border-top pt-4">
                      <div class="checkbox">
                        <input id="active1" type="checkbox" />
                        <label for="active1">
                          Active Bill to Bill Adjustment to this A ccount
                        </label>
                      </div>
                      <div class="checkbox">
                        <input id="active2" type="checkbox" />
                        <label for="active2">
                          Display Opening Balance as Seperate
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <!--/ branch permissions -->
              </div>
              <div role="tabpanel" class="tab-pane" id="Address">
                <!-- address -->
                <div class="row">
                  <!-- col -->
                  <div class="col-lg-4 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Contact Person</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Write Contact Person Name"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-4 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Gender</label>
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen29"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-30"
                            >Male</span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen30"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-30"
                          id="s2id_autogen30"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen30_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-30"
                              id="s2id_autogen30_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-30"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Male</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-4 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Profession</label>
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen31"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-32"
                            >Select Profession</span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen32"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-32"
                          id="s2id_autogen32"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen32_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-32"
                              id="s2id_autogen32_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-32"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select Profession</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                </div>
                <!-- row -->
                <div class="row">
                  <div class="col-12">
                    <h5 class="py-3">Address</h5>
                  </div>
                  <!-- col -->
                  <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                      <label>Address Line 1</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Address Line 1"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                      <label>Address Line 2</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Address Line 2"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Town</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Town Name"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group row">
                      <div class="col-10">
                        <label>Area</label>
                        <select
                          class="form-control show-tick ms select2"
                          data-placeholder="Select"
                        >
                          <option>Select</option>
                          <option>Customer</option>
                          <option>Type Customer</option>
                          <option>Vendor</option>
                          <option>Relish</option>
                        </select>
                      </div>
                      <div class="col-2 pl-0">
                        <a
                          href="javascript:void(0)"
                          class="formAddicon"
                          data-toggle="modal"
                          data-target="#addItem"
                          ><span class="icon-plus icomoon"></span
                        ></a>
                      </div>
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Pincode</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder='Pincode"'
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>District</label>
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen33"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-34"
                            >Select District</span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen34"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-34"
                          id="s2id_autogen34"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen34_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-34"
                              id="s2id_autogen34_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-34"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select District</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>State</label>
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen35"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-36"
                            >Select State</span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen36"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-36"
                          id="s2id_autogen36"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen36_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-36"
                              id="s2id_autogen36_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-36"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select State</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Country</label>
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen37"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-38"
                            >Select Country</span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen38"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-38"
                          id="s2id_autogen38"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen38_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-38"
                              id="s2id_autogen38_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-38"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select Country</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Email ID</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Email ID"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Phone Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Phone Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Alternative Phone Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Alternative Phone Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Mobile Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Mobile Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Alternative Mobile Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Alternative Mobile Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>STD Code</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="EX:040"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Blood Group</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="EX:B+"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Fax Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Fax Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Aadhar Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Aadhar Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Transport Name</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Transport Name"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>PAN Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="PAN Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Credit Limit</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Credit Limit"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>GSTIN Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="GSTIN Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Credit Days</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Credit Days"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Due Days</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Due Days"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Loyality Card Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Loyality Card Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Sales Tax Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Sales Tax Number"
                      />
                    </div>
                  </div>
                  <!-- /col -->
                </div>
                <!--/ row -->
                <!--/ address -->
              </div>
              <div role="tabpanel" class="tab-pane" id="Specialoption">
                <!-- special option -->
                <div class="row">
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Default Rate by Type</label>
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen39"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-40"
                            >Select Default Rate by Type</span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen40"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-40"
                          id="s2id_autogen40"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen40_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-40"
                              id="s2id_autogen40_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-40"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select Default Rate by Type</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Control Days</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Control Days"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <label>CAN Send SMS, Email</label>
                    <div class="form-group row">
                      <div class="checkbox col-6">
                        <input id="sms" type="checkbox" />
                        <label for="sms"> SMS </label>
                      </div>
                      <div class="checkbox col-6">
                        <input id="email" type="checkbox" />
                        <label for="email"> Emaail </label>
                      </div>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Date of Birth</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"
                            ><i class="zmdi zmdi-calendar"></i
                          ></span>
                        </div>
                        <input
                          type="text"
                          class="form-control datepicker"
                          placeholder="Please choose date ..."
                          data-dtp="dtp_JT9Aq"
                        />
                      </div>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>D.License Exp Date</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"
                            ><i class="zmdi zmdi-calendar"></i
                          ></span>
                        </div>
                        <input
                          type="text"
                          class="form-control datepicker"
                          placeholder="D.License Exp Date..."
                          data-dtp="dtp_uTFwW"
                        />
                      </div>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Anniversary Date</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"
                            ><i class="zmdi zmdi-calendar"></i
                          ></span>
                        </div>
                        <input
                          type="text"
                          class="form-control datepicker"
                          placeholder="Anniversary Date..."
                          data-dtp="dtp_KOHYc"
                        />
                      </div>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Contact Person Shipment</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Contact Person Shipment"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Spouse Name</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Spouse Name"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                </div>
                <div class="row pt-5">
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>TAN Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="TAN Number"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>DL 20B</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="DL 20B"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>DL 21B</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="DL 21B"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>MC Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="MC Number"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                </div>
                <!--/ special option -->
              </div>
              <div role="tabpanel" class="tab-pane" id="Bank">
                <!-- bank -->
                <div class="row">
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Bank Name</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Bank Name"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Account Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Account Number"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Account Holder Name</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Account Holder Name"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Branch Name</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Branch Name"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Address"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>BSR Code</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="BSR Code"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>IFSC Code</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="IFSC Code"
                      />
                    </div>
                  </div>
                  <!--/ col -->
                </div>
                <!--/ bankm -->
              </div>
              <div role="tabpanel" class="tab-pane" id="customFields">
                <!-- custom fields -->
                <table class="table m-b-0 kliqtable">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Gold Customers</th>
                      <td>Gold</td>
                    </tr>
                    <tr>
                      <th scope="row">Royal Customers</th>
                      <td>Royal</td>
                    </tr>
                    <tr>
                      <th scope="row">Silver Customers</th>
                      <td>Silver</td>
                    </tr>
                    <tr>
                      <th scope="row">VIP Customers</th>
                      <td>VIP</td>
                    </tr>
                  </tbody>
                </table>
                <!--/ customfields -->
              </div>
              <div role="tabpanel" class="tab-pane" id="gst">
                <!-- Gst -->
                <!-- row -->
                <div classs="row">
                  <div class="col-12">
                    <h5 class="py-3">GST Account Tagging</h5>
                  </div>
                  <!-- col -->
                  <div class="form-group row">
                    <div class="col-lg-2 text-right">
                      <label>GST Tax Rates</label>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen41"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-42"
                            >Select GST Tax Rates</span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen42"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-42"
                          id="s2id_autogen42"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen42_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-42"
                              id="s2id_autogen42_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-42"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select GST Tax Rates</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                </div>
                <!-- row -->
                <!-- row -->
                <div class="row">
                  <div class="col-lg-2 col-md-2 text-right col-sm-6">
                    <label class="text-right">CGST:</label>
                  </div>
                  <div class="col-lg-2 col-md-2">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control text-right"
                        value="0.00"
                      />
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen43"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-44"
                            >Select </span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen44"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-44"
                          id="s2id_autogen44"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen44_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-44"
                              id="s2id_autogen44_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-44"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen45"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-46"
                            >Select </span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen46"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-46"
                          id="s2id_autogen46"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen46_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-46"
                              id="s2id_autogen46_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-46"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                </div>
                <!--/ row -->
                <!-- row -->
                <div class="row">
                  <div class="col-lg-2 col-md-2 text-right col-sm-6">
                    <label class="text-right">SGST:</label>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-6">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control text-right"
                        value="0.00"
                      />
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen47"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-48"
                            >Select </span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen48"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-48"
                          id="s2id_autogen48"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen48_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-48"
                              id="s2id_autogen48_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-48"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen49"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-50"
                            >Select </span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen50"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-50"
                          id="s2id_autogen50"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen50_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-50"
                              id="s2id_autogen50_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-50"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                </div>
                <!--/ row -->
                <!-- row -->
                <div class="row">
                  <div class="col-lg-2 col-md-2 text-right col-sm-6">
                    <label class="text-right">IGST:</label>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-6">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control text-right"
                        value="0.00"
                      />
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen51"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-52"
                            >Select </span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen52"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-52"
                          id="s2id_autogen52"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen52_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-52"
                              id="s2id_autogen52_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-52"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div
                        class="
                          select2-container
                          form-control
                          show-tick
                          ms
                          select2
                        "
                        id="s2id_autogen53"
                      >
                        <a
                          href="javascript:void(0)"
                          class="select2-choice"
                          tabindex="-1"
                        >
                          <span class="select2-chosen" id="select2-chosen-54"
                            >Select </span
                          ><abbr class="select2-search-choice-close"></abbr>
                          <span class="select2-arrow" role="presentation"
                            ><b role="presentation"></b></span></a
                        ><label
                          for="s2id_autogen54"
                          class="select2-offscreen"
                        ></label
                        ><input
                          class="select2-focusser select2-offscreen"
                          type="text"
                          aria-haspopup="true"
                          role="button"
                          aria-labelledby="select2-chosen-54"
                          id="s2id_autogen54"
                        />
                        <div
                          class="
                            select2-drop
                            select2-display-none
                            select2-with-searchbox
                          "
                        >
                          <div class="select2-search">
                            <label
                              for="s2id_autogen54_search"
                              class="select2-offscreen"
                            ></label>
                            <input
                              type="text"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              spellcheck="false"
                              class="select2-input"
                              role="combobox"
                              aria-expanded="true"
                              aria-autocomplete="list"
                              aria-owns="select2-results-54"
                              id="s2id_autogen54_search"
                              placeholder=""
                            />
                          </div>
                          <ul
                            class="select2-results"
                            role="listbox"
                            id="select2-results-54"
                          ></ul>
                        </div>
                      </div>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Select"
                        tabindex="-1"
                        title=""
                        style="display: none"
                      >
                        <option>Select</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                </div>
                <!--/ row -->
                <!--/ Gst-->
              </div>
            </div>
          </div>
          <!--/ bootstrap tabs -->
        </div>
        <!--/ card body -->
        <div class="card-footer text-left w-100">
         
          <button class="btn redbtn" type="button">Another</button>
          <button class="btn redbtn" type="button">F3-Save</button>
         
          <button class="btn redbtn" type="button">Find</button>
         
         
          <button class="btn redbtn" type="button">Close</button>
          <button class="btn redbtn" type="button">Cancel</button>
          <button class="btn redbtn" type="button">Help</button>
        </div>
      </div>
    </main>
  
    <div class="modal fade" id="addItem" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <!-- body -->
  
        <!-- row -->
  
        <app-addnew-area></app-addnew-area>
  
        <!--/ row -->
  
        <!-- body -->
      </div>
    </div>
  
    <div class="modal fade" id="salesman" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="mainheader">
            <h4 class="title" id="largeModalLabel">salesman</h4>
          </div>
          <!-- body -->
          <div class="modal-body">
            <!-- row -->
            <div class="row">
              <div class="col-md-3 modal-sidebar">
                <h5>Select Location</h5>
                <div class="pt-3">
                  <div class="checkbox">
                    <input id="locguntur" type="checkbox" />
                    <label for="locguntur"> Guntur </label>
                  </div>
                  <div class="checkbox">
                    <input id="locNellore" type="checkbox" />
                    <label for="locNellore"> Nellore </label>
                  </div>
                  <div class="checkbox">
                    <input id="locOngole" type="checkbox" />
                    <label for="locOngole"> Ongole </label>
                  </div>
                  <div class="checkbox">
                    <input id="locSuryapet" type="checkbox" />
                    <label for="locSuryapet"> Suryapet </label>
                  </div>
                  <div class="checkbox">
                    <input id="locVijayawada" type="checkbox" />
                    <label for="locVijayawada"> Vijayawada </label>
                  </div>
                  <div class="checkbox">
                    <input id="locVijayanagaram" type="checkbox" />
                    <label for="locVijayanagaram"> Vijayanagaram </label>
                  </div>
                  <div class="checkbox">
                    <input id="locguntur" type="checkbox" />
                    <label for="locguntur"> Guntur </label>
                  </div>
                  <div class="checkbox">
                    <input id="locNellore" type="checkbox" />
                    <label for="locNellore"> Nellore </label>
                  </div>
                  <div class="checkbox">
                    <input id="locOngole" type="checkbox" />
                    <label for="locOngole"> Ongole </label>
                  </div>
                  <div class="checkbox">
                    <input id="locSuryapet" type="checkbox" />
                    <label for="locSuryapet"> Suryapet </label>
                  </div>
                  <div class="checkbox">
                    <input id="locVijayawada" type="checkbox" />
                    <label for="locVijayawada"> Vijayawada </label>
                  </div>
                  <div class="checkbox">
                    <input id="locVijayanagaram" type="checkbox" />
                    <label for="locVijayanagaram"> Vijayanagaram </label>
                  </div>
                  <div class="checkbox">
                    <input id="locguntur" type="checkbox" />
                    <label for="locguntur"> Guntur </label>
                  </div>
                  <div class="checkbox">
                    <input id="locNellore" type="checkbox" />
                    <label for="locNellore"> Nellore </label>
                  </div>
                  <div class="checkbox">
                    <input id="locOngole" type="checkbox" />
                    <label for="locOngole"> Ongole </label>
                  </div>
                  <div class="checkbox">
                    <input id="locSuryapet" type="checkbox" />
                    <label for="locSuryapet"> Suryapet </label>
                  </div>
                  <div class="checkbox">
                    <input id="locVijayawada" type="checkbox" />
                    <label for="locVijayawada"> Vijayawada </label>
                  </div>
                  <div class="checkbox">
                    <input id="locVijayanagaram" type="checkbox" />
                    <label for="locVijayanagaram"> Vijayanagaram </label>
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <div class="d-flex justify-content-between">
                  <h5>Area</h5>
                  <div class="checkbox">
                    <span class="d-inline-block pr-2">Status</span>
                    <input id="act01" type="checkbox" />
                    <label for="act01"> Active </label>
                  </div>
                </div>
                <!-- <app-salesman-creation></app-salesman-creation> -->
              </div>
            </div>
            <!--/ row -->
          </div>
          <!-- body -->
          <div class="card-footer text-left w-100">
            <button class="btn redbtn" type="button">New</button>
  
            <button class="btn redbtn" type="button">F3-Save</button>
            <button class="btn redbtn" type="button">Edit</button>
  
            <button class="btn redbtn" type="button">Delete</button>
  
            <button class="btn redbtn" data-dismiss="modal" type="button">
              Close
            </button>
            <button class="btn redbtn" type="button">Cancel</button>
            <button class="btn redbtn" type="button">Help</button>
          </div>
        </div>
      </div>
    </div>
    <!-- main body -->
  </div>
  